function asJSON(str) {
  let obj;
  try {
    obj = JSON.parse(str);
  } catch(e) {
    return false
  }
  return obj;
}
function objEqual(a,b) {
  return JSON.stringify(a) === JSON.stringify(b)
}
function copy(o) {
  return JSON.parse(JSON.stringify(o));
}

export {
  asJSON,
  objEqual,
  copy
}